// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__22wrx","title":"FrontImage_title__npm_W"};